/**
 * useReducedMotion — true wenn der User `prefers-reduced-motion: reduce`
 * konfiguriert hat. Komponenten nutzen das, um Framer-Motion-Animationen
 * runterzudrehen oder Auto-Play zu deaktivieren.
 *
 * Beispiel:
 *   const reducedMotion = useReducedMotion();
 *   <motion.div animate={{ opacity: 1 }} transition={{ duration: reducedMotion ? 0 : 0.18 }} />
 *
 * Globale CSS-Reduktion passiert ohnehin bereits in styles/globals.css —
 * dieser Hook ist nur für JS-gesteuerte Animations (Framer-Motion etc.).
 */
import { useMediaQuery } from "usehooks-ts";

export function useReducedMotion(): boolean {
  return useMediaQuery("(prefers-reduced-motion: reduce)", {
    defaultValue: false,
    initializeWithValue: true,
  });
}
